var map = {
	"./angle-left.svg": 6356,
	"./angle-right.svg": 671,
	"./arrow-left.svg": 6634,
	"./arrow-right.svg": 8264,
	"./check.svg": 5384,
	"./close.svg": 4241,
	"./info.svg": 9519,
	"./menu.svg": 219,
	"./plus.svg": 4132,
	"./x-color.svg": 7454,
	"./x.svg": 3029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 866;